import React, { PropsWithChildren } from 'react';

import styles from './styles.module.scss';

const NoWrap: React.FunctionComponent<PropsWithChildren> = ({ children }) => (
  <span className={styles.nowrap}>{children}</span>
);

export default NoWrap;
